import styled from 'styled-components';
import { pxToRem } from 'utils/scss';

export const LanguageContainer = styled.div`
  display: flex;
  gap: ${pxToRem('8px')};
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
`;
export const ChosenLanguage = styled.div`
  display: flex;
  align-items: center;
  gap: ${pxToRem('8px')};
`;

export const FlagImage = styled.img`
  width: ${pxToRem('15px')};
`;

export const UpArrow = styled.div`
  border: solid #467afb;
  border-width: 0 ${pxToRem('3px')} ${pxToRem('3px')} 0;
  display: inline-block;
  padding: ${pxToRem('3px')};
  transform: rotate(-135deg);
  -webkit-transform: rotate(-135deg);
`;

export const DownArrow = styled.div`
  border: solid #467afb;
  border-width: 0 ${pxToRem('3px')} ${pxToRem('3px')} 0;
  display: inline-block;
  padding: ${pxToRem('3px')};

  transform: ${props =>
    props.upsideDown ? 'rotate(225deg)' : 'rotate(45deg)'};
  -webkit-transform: ${props =>
    props.upsideDown ? 'rotate(225deg)' : 'rotate(45deg)'};
  transition-duration: 0.5s;
  transition-property: transform;
  -webkit-transition-duration: 0.5s;
  -moz-transition-property: transform;
`;

export const ArrowContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-left: ${pxToRem('10px')};
`;
